import { render, staticRenderFns } from "./ConstructionDetailForm.vue?vue&type=template&id=ada90c36&scoped=true"
import script from "./ConstructionDetailForm.vue?vue&type=script&lang=js"
export * from "./ConstructionDetailForm.vue?vue&type=script&lang=js"
import style0 from "./ConstructionDetailForm.vue?vue&type=style&index=0&id=ada90c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada90c36",
  null
  
)

export default component.exports